import { render, staticRenderFns } from "./pos-employee-deduct.vue?vue&type=template&id=1bbe5264"
import script from "./pos-employee-deduct.vue?vue&type=script&lang=js"
export * from "./pos-employee-deduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports